import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createRepository, updateRepository, deleteRepository } from '../../../../api/administration/edmsSettings/repositories';

export const useRepositoryMutations = (queryKey = ['repositories']) => {
  const queryClient = useQueryClient();

  const invalidateRepositories = async () => {
    await queryClient.invalidateQueries({ queryKey, exact: false });
    await queryClient.invalidateQueries({ queryKey: ['repositories', 'active'], exact: false });
  };

  const createMutation = useMutation({
    mutationFn: createRepository,
    onSuccess: () => invalidateRepositories(),
  });

  const updateMutation = useMutation({
    mutationFn: updateRepository,
    onSuccess: () => invalidateRepositories(),
  });

  const deleteMutation = useMutation({
    mutationFn: deleteRepository,
    onSuccess: () => invalidateRepositories(),
  });

  return {
    createMutation,
    updateMutation,
    deleteMutation,
  };
};

export default useRepositoryMutations;
